import { cookieRef } from '@layouts/stores/config'
import { themeConfig } from '@themeConfig'
import { createI18n } from 'vue-i18n'

const allLocales = Object.fromEntries(
  Object.entries(import.meta.glob('./locales/*.json', { eager: true }))
    .map(([key, value]) => [key.slice(10, -5), value.default]),
)

const messages = {}
const processedLocales = new Set()

Object.keys(allLocales).forEach(localeKey => {
  const baseLocale = localeKey.replace(/\+*$/, '')

  if (!processedLocales.has(baseLocale)) {
    processedLocales.add(baseLocale)

    const extensions = []
    let current = baseLocale
    let level = 0

    while (allLocales[current] !== undefined) {
      extensions.push(allLocales[current])
      level++
      current = baseLocale + '+'.repeat(level)
    }

    messages[baseLocale] = Object.assign({}, ...extensions)
  }
})

let _i18n = null

export const getI18n = () => {
  if (_i18n === null) {
    const languageCookie = cookieRef('language', themeConfig.app.i18n.defaultLocale)
    _i18n = createI18n({
      legacy: false,
      locale: languageCookie.value,
      fallbackLocale: themeConfig.app.i18n.defaultLocale,
      messages,
    })
  }

  return _i18n
}
export default function (app) {
  app.use(getI18n())
}
